export const isChromeBrowser = (browserName: string): boolean =>
  (browserName && browserName.includes('Chrome')) || browserName === 'Chromium';

export default isChromeBrowser;
